<template>
  <span class="rounded-full inline-flex" :class="classes">
    <span class="font-medium flex flex-nowrap gap-1 items-center justify-center px-1">
      <span :class="getAmountClass()" v-if="amount >= 0">{{ amount }}</span>
      <component
        :is="icon"
        class="h-3.5 w-3.5 inline-block"
        :class="{ 'mb-px mr-px': this.small }"
      />
      <span class="inline-block"><slot></slot></span>
    </span>
  </span>
</template>

<script>
import * as icons from '@heroicons/vue/solid';

export default {
  name: 'ViceBadge',
  components: {
    ...icons,
  },
  props: {
    amount: { type: Number, default: null },
    icon: { type: String },
    small: { type: Boolean, default: false },
    gray: { type: Boolean, default: false },
    green: { type: Boolean, default: false },
    red: { type: Boolean, default: false },
    brightRed: { type: Boolean, default: false },
    yellow: { type: Boolean, default: false },
    indigo: { type: Boolean, default: false },
    blue: { type: Boolean, default: false },
    purple: { type: Boolean, default: false },
    white: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },

  methods: {
    getAmountClass() {
      return this.amount ? 'mr-1' : '';
    },
  },
  computed: {
    hasText() {
      return !!this.$slots.default;
    },
    classes() {
      return {
        ...this.shapeClasses,
        ...this.colorClasses,
      };
    },
    shapeClasses() {
      return {
        'px-0.5 md:px-1.5 text-xxs': this.small,
        'px-2.5 text-xs': !this.small,
      };
    },

    colorClasses() {
      return {
        'bg-green-100 text-green-800': this.green,
        'bg-red-100 text-red-800': this.red,
        'bg-red-500 text-white': this.brightRed,
        'bg-gray-100 text-gray-800': this.gray,
        'bg-vice-light-yellow text-yellow-800': this.yellow,
        'bg-blue-100 text-blue-800': this.blue,
        'bg-purple-100 text-purple-800': this.purple,

        'bg-indigo-200 text-indigo-800': this.indigo,
        'bg-white text-black': this.white,
        'bg-gray-200 text-white': this.disabled,
      };
    },
  },
};
</script>
